import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M18.6 7h-3.2v-.75c0-.5967-.2529-1.169-.7029-1.591C14.247 4.237 13.6365 4 13 4h-1.6c-.6365 0-1.247.237-1.697.659C9.2528 5.081 9 5.6533 9 6.25V7H5.8c-.2122 0-.4157.079-.5657.2197S5 7.551 5 7.75s.0843.3897.2343.5303S5.5878 8.5 5.8 8.5h.8v8.25c0 .5967.2529 1.169.703 1.591S8.3634 19 9 19h6.4c.6365 0 1.247-.2371 1.6971-.659s.7029-.9943.7029-1.591V8.5h.8c.2122 0 .4157-.079.5657-.2197S19.4 7.949 19.4 7.75s-.0843-.3897-.2343-.5303S18.8122 7 18.6 7m-8-.75c0-.199.0843-.3897.2343-.5303S11.1878 5.5 11.4 5.5H13c.2122 0 .4157.079.5657.2197s.2343.3314.2343.5303V7h-3.2zm5.6 10.5c0 .1989-.0843.3897-.2343.5303s-.3535.2197-.5657.2197H9c-.2122 0-.4157-.079-.5657-.2197S8.2 16.9489 8.2 16.75V8.5h8z"
}), "Delete", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
